import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {defaultRegion} from '../../../../../_metronic/helpers'
import {REGION, REGION_API_URLS} from '../../../../Utils/Constant/ConstantForWebsite'

const API_URL = ENV().REACT_APP_API_URL
const API_URL_V3 = ENV().REACT_APP_API_V3_URL

const initialState = {
  endUserLandingPage: [],
  endUserOptOutPage: [],
  shortLongUrl: {},
  contactFormData: {},
  contactFormDataDefault: {},
  contactFormDataLoading: false,
}

const fetchDataApiV3 = async (url: string, data: any, region: string) => {
  const domain =
    region !== defaultRegion
      ? (region && REGION_API_URLS[region.toUpperCase()]) || API_URL_V3
      : API_URL_V3

  const response = await axios.post(`${domain}${url}`, data, {
    headers: {region: region},
  })

  return response.data
}

export const getLandingPageData: any = createAsyncThunk(
  'getLandingPageData',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}landing/${data?.url}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const getOptoutData: any = createAsyncThunk('getOptoutData', async (data: any, thunkApi) => {
  const response = await axios.get(`${API_URL}optout/${data?.url}`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })

  thunkApi.dispatch(stopLoading())
  return response.data
})

export const getOptoutInternationalData: any = createAsyncThunk(
  'getOptoutInternationalData',
  async (data: any, thunkApi) => {
    const response = await fetchDataApiV3(
      'tracking-link-public',
      {
        action: 'get_opt_click',
        data: {
          code: data?.url,
        },
      },
      REGION.US
    )

    thunkApi.dispatch(stopLoading())
    return response?.data
  }
)

export const responseOptoutInternationalData: any = createAsyncThunk(
  'responseOptoutData',
  async (data: any, thunkApi) => {
    const response = await fetchDataApiV3(
      'tracking-link-public',
      {
        action: 'update_opt_click',
        data: {
          code: data?.url,
        },
      },
      REGION.US
    )

    if (response?.is_error) {
      toast.error(response?.message)
    } else {
      toast.success(response?.message)
    }

    thunkApi.dispatch(stopLoading())
    return response?.data
  }
)

export const responseOptoutData: any = createAsyncThunk(
  'responseOptoutData',
  async (data: any, thunkApi) => {
    const response = await axios.put(`${API_URL}optout/${data?.url}`, data.response)
    {
      response.data.result === 'Response Already Submitted'
        ? toast.error(response.data.result)
        : toast.success(response.data.result)
    }
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const ShortToLongUrlData: any = createAsyncThunk(
  'responseOptoutData',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}shortUrl/${data}`)
    // {
    //   response.data.result === 'Response Already Submitted'
    //     ? toast.error(response.data.result)
    //     : toast.success(response.data.result)
    // }
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const responseLandingPageData: any = createAsyncThunk(
  'responseLandingPageData',
  async (data: any, thunkApi) => {
    const response = await axios.put(`${API_URL}landing/${data?.url}`, data.response, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    {
      response.data.result === 'Response Already Submitted'
        ? toast.error(response.data.result)
        : toast.success(response.data.result)
    }
    return response.data
  }
)

export const fetchContactFormData: any = createAsyncThunk(
  'fetchContactFormData',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}contact-form-public/${data?.id}/active`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const postContactFormData: any = createAsyncThunk(
  'postContactFormData',
  async (params: any, thunkApi) => {
    const response = await axios.post(
      `${API_URL}contact-form-public/${params?.id}/action`,
      params.data,
      {}
    )
    if (response.status > 199 && response.status < 300) {
      toast.success('Form submission successful')
    }
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const EndUserSlice = createSlice({
  name: 'EndUserSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getOptoutData.fulfilled, (state, action) => {
      return {...state, endUserOptOutPage: action?.payload}
    })
    builder.addCase(getOptoutInternationalData.fulfilled, (state, action) => {
      return {...state, endUserOptOutPage: action?.payload}
    })
    builder.addCase(getLandingPageData.fulfilled, (state, action) => {
      return {...state, endUserLandingPage: action?.payload}
    })
    builder.addCase(ShortToLongUrlData.fulfilled, (state, action) => {
      return {...state, shortLongUrl: action?.payload}
    })
    builder.addCase(fetchContactFormData.fulfilled, (state, action) => {
      return {
        ...state,
        contactFormData: action?.payload,
        contactFormDataDefault: {...action?.payload},
      }
    })
    // Post contact form data
    builder.addCase(postContactFormData.pending, (state) => {
      state.contactFormDataLoading = true
    })
    builder.addCase(postContactFormData.fulfilled, (state) => {
      return {
        ...state,
        contactFormDataLoading: false,
        contactFormData: {...state.contactFormDataDefault},
      }
    })
    builder.addCase(postContactFormData.rejected, (state) => {
      return {...state, contactFormDataLoading: false}
    })
  },
})
export const getOuptoutData = (state: any) =>
  state?.endUserData?.endUserOptOutPage?.result?.optoutId

export const getOptoutCustomBranding = (state: any) => ({
  customLogo: state?.endUserData?.endUserOptOutPage?.customLogo || '',
  customTitle: state?.endUserData?.endUserOptOutPage?.customTitle || '',
  customFooter: state?.endUserData?.endUserOptOutPage?.customFooter || '',
})

export const getOuptoutInternationalData = (state: any) => state?.endUserData?.endUserOptOutPage

export const getLandingPageDetail = (state: any) =>
  state?.endUserData?.endUserLandingPage?.result?.landingPageId

export const getContactFormData = (state: any) => state?.endUserData?.contactFormData?.data
export const getContactFormDataLoading = (state: any) => state?.endUserData?.contactFormDataLoading

export default EndUserSlice.reducer
